module.exports = __webpack_public_path__ + "img/success.a2a0dcf.png";